import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import withRoot from '../withRoot';
import DamageTypes from './DamageTypes.json';
import DiceUtil from '../utils/DiceUtil';
import { IconButton, Typography, ListItem, ListItemText, ListItemSecondaryAction, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, List } from '@material-ui/core';
import CasinoIcon from '@material-ui/icons/Casino';
import Switch from '@material-ui/core/Switch';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = theme => ({
    root: {
        margin: theme.spacing.unit,
    },
    expansion: {
        width: "300px",
    },
    listText: {
        width: "180px",
    },
});

class DamageTypeRoller extends Component {
    state = {
        result: null,
        availableTypes: Array(DamageTypes.values.length).fill(true),
    };

    handleToggle = index => () => {
        const availableTypes = this.state.availableTypes.concat();
        availableTypes[index] = !availableTypes[index];
        this.setState({ availableTypes: availableTypes });
    };

    rollDamageType() {
        const myDamageTypes = [];
        for (let i = 0; i < DamageTypes.values.length; i++) {
            if (this.state.availableTypes[i]) {
                myDamageTypes[myDamageTypes.length] = DamageTypes.values[i];
            }
        }

        const roll = DiceUtil.dice(myDamageTypes.length) - 1;
        this.setState({ result: myDamageTypes[roll] });
    }

    render() {
        const { classes } = this.props;

        const damageTypeList = DamageTypes.values.map((value, index) => (
            <ListItem key={index}>
                <ListItemText primary={value} className={classes.listText} />
                <ListItemSecondaryAction>
                    <Switch onChange={this.handleToggle(index)} checked={this.state.availableTypes[index]} />
                </ListItemSecondaryAction>
            </ListItem>
        ));

        return (
            <div className={classes.root}>
                <ExpansionPanel className={classes.expansion}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>Filters</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <List>
                            {damageTypeList}
                        </List>
                    </ExpansionPanelDetails>
                </ExpansionPanel>

                <Typography className={classes.root}>
                    <IconButton color="inherit" aria-label="Menu" onClick={() => this.rollDamageType()}>
                        <CasinoIcon />
                    </IconButton>

                    {this.state.result}
                </Typography>
            </div>
        );
    }
}

DamageTypeRoller.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRoot("Damage Type Roller", withStyles(styles)(DamageTypeRoller));


// WEBPACK FOOTER //
// ./src/item-helpers/DamageTypeRoller.js